import React from "react";
import "./Services.css"; // Fichier CSS pour les styles
import SEO from "../SEO/SEO";

const Services = () => {
  const services = [
    {
      title: "Airport & Disneyland Transfers",
      description:
        "We provide private and personalized transfers to and from any destination in Paris, including Charles de Gaulle, Orly, and Beauvais airports. Perfect for families and groups visiting Disneyland.",
      images: [
        "/images/disneyland-Parisbg.gif",
        "/images/disneyland-Parisbg2.gif",
      ],
    },
    {
      title: "Door-to-Door Service",
      description:
        "Enjoy a private door-to-door service for dinners, shows, museums, shopping, or any destination of your choice. Hire our cars for half or full-day services.",
      images: ["/images/louvre.gif", "/images/chantilly.gif"],
    },
    {
      title: "Half-Day Tourist Destinations",
      description:
        "Discover half-day tourist destinations around Paris like Notre Dame, Pont Neuf, and more with our friendly drivers.",
      images: ["/images/notreda.gif", "/images/PONT9.gif"],
    },
    {
      title: "Full-Day Tourist Destinations",
      description:
        "Explore far destinations like the D-Day beaches, Deauville, Honfleur, and the castles of the Loire Valley with a full-day service.",
      images: [
        "/images/fontainebleau.gif",
        "/images/Chartreschatedrale.gif",
      ],
    },
  ];

  return (
<div>
    <SEO
        title="Our Services - RS Transports"
        description="Explore RS Transports' wide range of services, including airport and Disneyland transfers, private door-to-door rides, and customized half or full-day tours. Enjoy seamless transportation to Paris airports, tourist destinations, and more."
        keywords="RS Transports services, airport transfers, Disneyland transfers, door-to-door service, Paris transportation, tourist destinations, half-day tours, full-day tours, private transfers, Loire Valley castles, D-Day beaches"
    />
    <div className="container py-5">
      <h1 className="text-center mb-4">Our Services</h1>
      <div className="row">
        {services.map((service, index) => (
          <div className="col-12 mb-5" key={index}>
            <div className="card  text-white">
              <div className="card-header">
                <h3 className="text-center">{service.title}</h3>
              </div>
              <div className="card-body">
                <p className="card-text text-center">{service.description}</p>
                <div className="d-flex justify-content-center gap-3">
                  {service.images.map((image, imgIndex) => (
                    <img
                      key={imgIndex}
                      src={image}
                      alt={service.title}
                      className="service-img"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
</div>
  );
};

export default Services;
